import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { nextAsset } from '../../../../components/nextAsset';

export const SmartlinksLinkfireAlternativeBenefits: React.FC = () => {
  const intl = useIntl();

  return (
    <Container className="py-5">
      <p className="main-header text-center pt-5">
        {intl.formatMessage({
          id: 'sml.web.smart-links.linkfire_alternative.benefits.title',
          defaultMessage: 'Key Benefits'
        })}
      </p>
      <Row className="align-items-center">
        <Col xs={12} lg={6} className="order-lg-2 text-center">
          <img
            src={nextAsset(`images/smartLinks/alternative/grow-your-audience.png`, false, { w: 900 })}
            alt=""
            className="img-fluid"
            style={{ width: '50%' }}
          />
        </Col>
        <Col xs={12} lg={6}>
          <p className="fs-4 fw-bold">
            {intl.formatMessage({
              id: 'sml.web.smart-links.linkfire_alternative.benefits.grow_audience.title',
              defaultMessage: 'Grow your audience with playlists'
            })}
          </p>
          <p className="fs-4">
            {intl.formatMessage({
              id: 'sml.web.smart-links.linkfire_alternative.benefits.grow_audience.description',
              defaultMessage:
                'Linkfire revolves around release links, but playlists - not albums - are the most popular way we consume music. Create your playlist once and publish it across all streaming platforms.'
            })}
          </p>
          <ul className="ps-4 fs-4">
            <li className="py-2">
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.benefits.grow_audience.list.1',
                defaultMessage: 'Auto-sync'
              })}
            </li>
            <li className="py-2">
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.benefits.grow_audience.list.2',
                defaultMessage: '20 platforms supported'
              })}
            </li>
            <li className="py-2">
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.benefits.grow_audience.list.3',
                defaultMessage: 'Responsive design'
              })}
            </li>
          </ul>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col xs={12} lg={6} className="mt-5">
          <img
            src={nextAsset(`images/smartLinks/alternative/level-up-with-premium-features.png`, false, { w: 900 })}
            alt=""
            className="img-fluid p-5"
          />
        </Col>
        <Col xs={12} lg={6} className="mt-5">
          <p className="fw-bold fs-4">
            {intl.formatMessage({
              id: 'sml.web.smart-links.linkfire_alternative.benefits.level_up.title',
              defaultMessage: 'Level up with premium features'
            })}
          </p>
          <p className="fs-4">
            {intl.formatMessage({
              id: 'sml.web.smart-links.linkfire_alternative.benefits.level_up.description',
              defaultMessage: 'Make the most out of your marketing game with our advanced tools:'
            })}
          </p>
          <ul className="ps-4 fs-4">
            <li className="py-2">
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.benefits.level_up.list.1',
                defaultMessage: 'Pre-saves'
              })}
            </li>
            <li className="py-2">
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.benefits.level_up.list.2',
                defaultMessage: 'Pixel remarketing'
              })}
            </li>
            <li className="py-2">
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.benefits.level_up.list.3',
                defaultMessage: 'Analytics'
              })}
            </li>
            <li className="py-2">
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.benefits.level_up.list.4',
                defaultMessage: 'Embed player'
              })}
            </li>
            <li className="py-2">
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.benefits.level_up.list.5',
                defaultMessage: 'Multiple artist accounts under one license'
              })}
            </li>
          </ul>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col xs={12} lg={6} className="order-lg-2 mt-5 text-center">
          <img
            src={nextAsset(`images/smartLinks/alternative/customize.png`, false, { w: 900 })}
            alt=""
            className="img-fluid"
            style={{ width: '50%' }}
          />
        </Col>
        <Col xs={12} lg={6} className="mt-5">
          <p className="fw-bold fs-4">
            {intl.formatMessage({
              id: 'sml.web.smart-links.linkfire_alternative.benefits.customize.title',
              defaultMessage: 'Customize, customize, customize'
            })}
          </p>
          <p className="fs-4">
            {intl.formatMessage({
              id: 'sml.web.smart-links.linkfire_alternative.benefits.customize.description',
              defaultMessage:
                'Get full control over your text, links and images. Create a Smart Link that is a perfect match for your brand.'
            })}
          </p>
          <ul className="ps-4 fs-4">
            <li className="py-2">
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.benefits.customize.list.1',
                defaultMessage: 'Pick artwork and background image'
              })}
            </li>
            <li className="py-2">
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.benefits.customize.list.2',
                defaultMessage: 'Customize URL'
              })}
            </li>
            <li className="py-2">
              {intl.formatMessage({
                id: 'sml.web.smart-links.linkfire_alternative.benefits.customize.list.3',
                defaultMessage: 'Rearrange content blocks'
              })}
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
};
